function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_38",
  className: "body",
  "data-name": "Path 38",
  d: "M1035.47 250.156h-25.9v-36.625h17.746l8.153 8.153z",
  transform: "translate(-1009.571 -213.531)",
  fill: "#98c3d9"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  className: "corner",
  "data-name": "Path 39",
  d: "M1039.289 221.684h8.152l-8.152-8.153z",
  transform: "translate(-1021.127 -213.531)",
  fill: "#002d56"
});

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "File_Default",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.315,
    height: 36.625,
    viewBox: "0 0 26.315 36.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iRmlsZV9EZWZhdWx0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNi4zMTUiIGhlaWdodD0iMzYuNjI1IiB2aWV3Qm94PSIwIDAgMjYuMzE1IDM2LjYyNSI+CiAgPHBhdGggaWQ9IlBhdGhfMzgiIGNsYXNzPSJib2R5IiBkYXRhLW5hbWU9IlBhdGggMzgiIGQ9Ik0xMDM1LjQ3LDI1MC4xNTZoLTI1LjlWMjEzLjUzMWgxNy43NDZsOC4xNTMsOC4xNTNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTAwOS41NzEgLTIxMy41MzEpIiBmaWxsPSIjOThjM2Q5Ii8+CiAgPHBhdGggaWQ9IlBhdGhfMzkiIGNsYXNzPSJjb3JuZXIiIGRhdGEtbmFtZT0iUGF0aCAzOSIgZD0iTTEwMzkuMjg5LDIyMS42ODRoOC4xNTJsLTguMTUyLTguMTUzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwMjEuMTI3IC0yMTMuNTMxKSIgZmlsbD0iIzAwMmQ1NiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };